"use strict";
/*
 * Permissions management system, define access level for each of
 * your server apis, and restrict users by giving them access levels
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsWrapperFE = void 0;
const ts_common_1 = require("@nu-art/ts-common");
const analytics_1 = require("firebase/analytics");
/**
 AnalyticsWrapperFE provides a wrapper around the Firebase Analytics library for frontend (FE) use.
 It provides methods for setting user IDs, setting the current screen, enabling or disabling analytics collection,
 setting custom user properties, and logging events.
 */
class AnalyticsWrapperFE extends ts_common_1.Logger {
    constructor(app) {
        super();
        this.analytics = (0, analytics_1.getAnalytics)(app);
    }
    setUserId(userId, options) {
        (0, analytics_1.setUserId)(this.analytics, userId, options);
    }
    /**
     * Set the current screen for the user
     * @param screenName
     * @param options
     */
    setCurrentScreen(screenName, options) {
        (0, analytics_1.setCurrentScreen)(this.analytics, screenName, options);
    }
    /**
     * Enable or disable analytics collection
     * @param enabled
     */
    setAnalyticsCollectionEnabled(enabled) {
        (0, analytics_1.setAnalyticsCollectionEnabled)(this.analytics, enabled);
    }
    /**
     * Set custom user properties for analytics
     * @param properties
     * @param options
     */
    setUserProperties(properties, options) {
        (0, analytics_1.setUserProperties)(this.analytics, properties);
    }
    logEvent(eventName, eventParams, options) {
        return (0, analytics_1.logEvent)(this.analytics, eventName, eventParams, options);
    }
}
exports.AnalyticsWrapperFE = AnalyticsWrapperFE;
